import { faRightLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import { configState } from "../../context/configState";

const CustomLinkToast = (txnHash?: any) => {
  return (
    <a
      className="toast-info"
      href={`https://secretnodes.com/pulsar/transactions/${txnHash.hash}`}
      target="_blank"
    >
      <div>View Transaction</div>
    </a>
  );
};

export default CustomLinkToast;
